import { Route } from '@angular/router';
import { SettingPermissions } from '@backoffice/shared/bo/util-permissions';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { SettingSpotConfigurationListComponent } from './setting-spot-configuration-list.component';

export const settingSpotConfigurationRoute: Route = {
  path: 'spotConfigurations',
  component: SettingSpotConfigurationListComponent,
  canActivate: [ngxPermissionsGuard],
  data: {
    permissions: {
      only: SettingPermissions.settingSpot,
    },
  },
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import(
          '../setting-spot-configuration-details/setting-spot-configuration-details.component'
        ).then((mod) => mod.SettingSpotConfigurationDetailsComponent),
      canDeactivate: [CanDeactivateGuard],
    },
  ],
};
